"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BaseModel_1 = require("./BaseModel");
var Commit_1 = require("./Commit");
var Change_1 = require("./Change");
var moment = require("moment");
/** Class representing an user. */
var Release = /** @class */function (_super) {
  __extends(Release, _super);
  function Release(properties) {
    var _this = this;
    var _a;
    _this = _super.call(this, {}) || this;
    _this._id = properties._id;
    _this.project = properties.project;
    _this.commit = new Commit_1.default((_a = properties.commit) !== null && _a !== void 0 ? _a : {});
    _this.changes = (properties.changes || []).map(function (change) {
      return new Change_1.default(change);
    });
    _this.version = properties.version;
    _this.date = moment(properties.date);
    _this.title = properties.title;
    _this.description = properties.description;
    return _this;
  }
  Release.prototype.localizedTitle = function (lang) {
    if (!this.title) return null;
    return lang in this.title ? this.title[lang] : this.title[Object.keys(this.title)[0]];
  };
  Release.prototype.hasFeatures = function () {
    return this.features().length > 0;
  };
  Release.prototype.features = function () {
    return this.changes.filter(function (change) {
      return change.isFeature();
    });
  };
  Release.prototype.hasBugFixes = function () {
    return this.bugFixes().length > 0;
  };
  Release.prototype.bugFixes = function () {
    return this.changes.filter(function (change) {
      return change.isBugFix();
    });
  };
  return Release;
}(BaseModel_1.default);
exports.default = Release;